var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReoBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 20C42 29.9411 33.9411 38 24 38C14.0589 38 6 29.9411 6 20C6 10.0589 14.0589 2 24 2C33.9411 2 42 10.0589 42 20Z",
    fill: "url(#paint0_linear_2192_6977)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 36H27L26 44C26 45.1046 25.1046 46 24 46C22.8954 46 22 45.1046 22 44L21 36Z",
    fill: "url(#paint1_linear_2192_6977)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5139 7.64982C24.2037 7.43883 23.796 7.43883 23.4858 7.64982L12.8521 14.8827C12.6019 15.0529 12.4521 15.3358 12.4521 15.6384V29.54C12.4521 30.0448 12.8613 30.454 13.3661 30.454H15.3735V18.9791C15.3735 18.4743 15.7827 18.0651 16.2875 18.0651H31.8263C32.331 18.0651 32.7402 18.4743 32.7402 18.9791V30.454H34.6336C35.1384 30.454 35.5476 30.0448 35.5476 29.54V15.6384C35.5476 15.3358 35.3978 15.0529 35.1476 14.8827L24.5139 7.64982ZM21.5937 20.0285H23.3149V20.7936C23.3149 21.1777 23.6264 21.4892 24.0106 21.4892C24.3948 21.4892 24.7062 21.1777 24.7062 20.7936V20.0285H26.3923C26.7288 20.0285 27.0016 20.3013 27.0016 20.6378V24.1495C27.0016 24.486 26.7288 24.7588 26.3923 24.7588H21.5937C21.2572 24.7588 20.9844 24.486 20.9844 24.1495V20.6378C20.9844 20.3013 21.2572 20.0285 21.5937 20.0285ZM19.9409 25.7237H18.2197C17.8831 25.7237 17.6104 25.9965 17.6104 26.333V29.8447C17.6104 30.1812 17.8831 30.454 18.2197 30.454H23.0182C23.3548 30.454 23.6276 30.1812 23.6276 29.8447V26.333C23.6276 25.9965 23.3548 25.7237 23.0182 25.7237H21.3322V26.4886C21.3322 26.8728 21.0207 27.1843 20.6365 27.1843C20.2524 27.1843 19.9409 26.8728 19.9409 26.4886V25.7237ZM25.1415 25.7237H26.8628V26.4886C26.8628 26.8728 27.1742 27.1843 27.5584 27.1843C27.9426 27.1843 28.254 26.8728 28.254 26.4886V25.7237H29.9401C30.2766 25.7237 30.5494 25.9965 30.5494 26.333V29.8447C30.5494 30.1812 30.2766 30.454 29.9401 30.454H25.1415C24.805 30.454 24.5322 30.1812 24.5322 29.8447V26.333C24.5322 25.9965 24.805 25.7237 25.1415 25.7237Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2192_6977)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.7666,
    y: 45.0825,
    width: 8.35156,
    height: 0.91748,
    rx: 0.45874,
    fill: "#5E5E5E",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2192_6977",
    x: 17.7666,
    y: 43.0825,
    width: 12.3516,
    height: 4.91748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2192_6977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2192_6977",
    x1: 56.3437,
    y1: -1.60938,
    x2: -6.02522,
    y2: 35.9465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB073"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2192_6977",
    x1: 56.3437,
    y1: -1.60938,
    x2: -6.02522,
    y2: 35.9465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB073"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReoBasic);
export default __webpack_public_path__ + "static/media/iconReoBasic.29d93d0ebd9ae1e2660b32751e4c4e6b.svg";
export { ForwardRef as ReactComponent };